import { Menu } from '../menu';
import { ProductSection } from './product-section';

export class PlantlifeCheapWeedProductSection extends ProductSection {
  getBorderColor(menu: Menu): string {
    return menu?.menuOptions?.bodyBackgroundColor;
  }
}
